import { nanoid } from 'nanoid';
import { OriginVerify } from '../../types/distribution';
import { ComponentError, JoiErrorResponse } from '../../types/misc';
import emptyStringToUndefined from '../emptyStringToUndefined';

interface SaveOriginVerifyResponse {
    success: boolean,
    originVerify?: OriginVerify,
    errors: ComponentError[]
}

const saveOriginVerify = async (token: string, distributionName: String, originId: string, originVerify: OriginVerify): Promise<SaveOriginVerifyResponse> => {
    const url = `${process.env.REACT_APP_ADN_MANAGEMENT_BASE_URL}/v1/distributions/${distributionName}/origins/${originId}/originVerify`;
    const response = await fetch(url, {
        method: 'PUT',
        headers: {
            Authorization: `Bearer ${token}`,
            Accept: 'application/json ',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(emptyStringToUndefined(originVerify))
    });

    if (response.status === 400) {
        const error = (await response.json());

        // not a joi error
        if (!error.validation || !error.validation.errors) {
            return {
                success: false,
                errors: [{
                    message: error.message,
                    path: '',
                    uiId: nanoid()
                }]
            };
        }

        const joiError = error as JoiErrorResponse;
        return {
            success: false,
            errors: joiError.validation.errors
        };
    }

    if (!response.ok) {
        throw new Error(`Unexpected error when saving the origin verify config. Got status code ${response.status}`);
    }

    const result = await response.json();
    return {
        success: true,
        originVerify: result,
        errors: []
    };
};

export default saveOriginVerify;
